export class ConfigType {
    name = '';
    id = '';
    schema = {};
    tags: any = {};
};